// extracted by mini-css-extract-plugin
export default {"stepsContainer":"StepsContainer_stepsContainer__YaSag","stepWrapper":"StepsContainer_stepWrapper__akl+V","logoWrapper":"StepsContainer_logoWrapper__rdRIZ"};